import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { cmdOpenTouchMenu } from '../commands.js';

@customElement('hamburger-button')
export class HamburgerButton extends LitElement {
  static styles = css`
    :host {
      position: absolute;
      top: env(safe-area-inset-top, 12px);
      left: env(safe-area-inset-left, 12px);
      pointer-events: auto;
      cursor: pointer;
      padding: 10px;
    }
    .bar {
      width: 28px;
      height: 3px;
      background: #b3b3b3;
      margin: 5px 0;
      border-radius: 1px;
    }
  `;

  render() {
    return html`
      <div @click=${cmdOpenTouchMenu}>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
    `;
  }
}
